import axios from 'axios';
import { apiPaths } from 'constants/path';
import { tokenHeader } from 'functions/apiFunctions';
import { IDPatientListApi } from 'models/DCK/DCKApiTypes';

class DCKPatientApi {
    async patientGetList(url: string, token: string): Promise<IDPatientListApi> {
        try {
            const response = await axios.get(apiPaths.getPatientList + url + '/20', {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export const patientApi = new DCKPatientApi();
